"use client";

import { track } from "@vercel/analytics";
import type { ReactNode } from "react";
import { Button, type ButtonVariant } from "@/components/ui/button";
import type { Plan } from "@/lib/billing/polar-products";

export type CheckoutSource =
  | "changelog"
  | "cheat-sheet"
  | "homepage"
  | "resubscribe"
  | "welcome";

interface CheckoutButtonProps {
  children: ReactNode;
  className?: string;
  plan: Plan;
  source: CheckoutSource;
  variant: ButtonVariant;
}

export function CheckoutButton({
  children,
  className,
  plan,
  source,
  variant,
}: CheckoutButtonProps) {
  return (
    <Button
      className={className}
      href={`/checkout?plan=${plan}`}
      native
      onClick={() => track("Checkout Started", { plan, source })}
      rounded
      size="xl"
      static={true}
      variant={variant}
    >
      {children}
    </Button>
  );
}
